var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"sitcon-map"}},[_c('div',{style:({ width: _vm.width, height: _vm.height })}),_c('div',{staticClass:"sitetext"},[_vm._v("中央研究院人文社會科學館")])])}
var staticRenderFns = []

export { render, staticRenderFns }